import React from "react";
import useCheckMobile from "./Hooks/useCheckMobile";
import Btn from "../../Components/Btn/Btn";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";

const CheckMobile = () => {
  const { setForm, loading, check } = useCheckMobile();
  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="check-mobile">
            <div className="check-box">
              <div className="check-img">
                <img
                  src={require("../../assets/images/logo.png")}
                  style={{ width: "120px", objectFit: "contain" }}
                />
              </div>
              <div className="check-title">
                <p className="title">ورود</p>
                <p className="content">
                  برای ورود لطفا شماره مبایل خود را وارد نمایید
                </p>
              </div>
              <div className="check-input">
                <input
                  className="content"
                  onChange={({ target: { value } }) => {
                    setForm({ mobile: value });
                  }}
                />
              </div>
              <div className="check-button">
                <div className="content" onClick={check}>
                  {loading ? (
                    <Spinner
                      animation="border"
                      role="status"
                      style={{ color: "white" }}
                      size="sm"
                    ></Spinner>
                  ) : (
                    <span className="textBtn">ورود</span>
                  )}
                </div>
              </div>
              <div className="check-warning">
                <p className="text mt-3">
                  ورود شما به معنای قبول شرایط صنعتبان و قوانین
                  <Link to={"/PrivacyPolicy"} className="mx-1" style={{display:"inline-block"}}>
                    حریم خصوصی
                  </Link>
                  می باشد.
                </p>
              </div>
              <div className="check-footnote">
                <p className="title">نیازمندی های رایگان صنعت</p>
                <p className="text">تلفن پشتیبانی: 02191027127</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckMobile;
